var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36.5 21.8",
    style: {
      enableBackground: "new 0 0 36.5 21.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group_24664",
    transform: "translate(0.226 0.223)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_8667",
    style: {
      fill: "none",
      stroke: "#005BA9",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M2.3,0.3h31.5 c1.1,0,2,0.9,2,2V19c0,1.1-0.9,2-2,2H2.3c-1.1,0-2-0.9-2-2V2.3C0.3,1.2,1.2,0.3,2.3,0.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20612",
    style: {
      fill: "none",
      stroke: "#005BA9",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M1.7,1.1L18,10.3l16.4-9.2"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_400",
    style: {
      fill: "none",
      stroke: "#005BA9",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 14.6,
    y1: 12.4,
    x2: 5.3,
    y2: 17.7
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_401",
    style: {
      fill: "none",
      stroke: "#005BA9",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 30.7,
    y1: 17.6,
    x2: 21.5,
    y2: 12.4
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/Mail.06ff91b8f7477058a085117ddc2e75ef.svg";
export { ForwardRef as ReactComponent };